import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"

const { WithSuspense: Checkout } = lazyloadHelper(
    () => import(/* webpackChunkName: "Checkout" */ "./Checkout"),
)
const { WithSuspense: OrderConfirmation } = lazyloadHelper(
    () => import(/* webpackChunkName: "Checkout" */ "./OrderConfirmation"),
)
const { WithSuspense: HandoverPicker } = lazyloadHelper(
    () => import(/* webpackChunkName: "Checkout" */ "./HandoverPicker"),
)

export { Checkout, OrderConfirmation, HandoverPicker }
